export default __webpack_public_path__ + "static/media/usdt.1b7b9388.svg";